import logo from './logo.svg';
import './App.css';


import Slider2 from './HomePagework/secondslide';
// import Creatingslide from './Creatingslide';
import ThirdSlide from './HomePagework/Thirdslide';
import AllRoutes from './AllRoutes/AllRoutes';
import Main from './HomePagework/Main';
function App() {
  return (
    <div className="App">
 <AllRoutes/>
{/* <Main/> */}



    </div>
  );
}

export default App;
